export default {
    home: "Casa",
    order: {
        submit: "Ordine di revisione"
    },
    tunnel: {
        loginVerification: "Verifica dell'accesso",
        addressVerification: "Verifica dell'indirizzo"
    },
    catalog: "Catalogare",
    all: "Tutto",
    return: {
        return: "Ritorno"
    },
    errors: {
        404: "@:views.errors.404.title"
    },
    impersonation: "Ordine per conto di",
    approvals: "Approvazioni",
    delegate: "Delegati",
    employees: "I miei dipendenti",
}